import timerBadge from 'assets/Baba/timer-ribbon.png';
import { StyledBabaTimerBadge } from './style';

export const BabaTimerBadge: React.FC<{ timer?: string }> = ({ timer }) => {
  return (
    <StyledBabaTimerBadge>
      {timer && (
        <>
          <img src={timerBadge} alt="timer-badge" />
          <div className="timer-badge-text">{timer}</div>
        </>
      )}
    </StyledBabaTimerBadge>
  );
};
